export const version = '0.795.0'
export const chameleonWebVersion = '9.14.0'
export const chameleonCoreVersion = '7.9.2'
